import { Link } from 'react-router-dom';

import { type weeklyReportKnownIssue } from '../../services/api/weekly-report';

interface KnownIssuesListProps {
  issues: weeklyReportKnownIssue[];
  onToggleStatus: (issue: weeklyReportKnownIssue) => void;
  isToggling: boolean;
}

export const KnownIssuesList = ({ issues, onToggleStatus, isToggling }: KnownIssuesListProps) => {
  if (issues.length === 0) {
    return <p className="text-sm text-slate-500">Inga rapporterade ärenden denna vecka.</p>;
  }

  return (
    <ul className="space-y-1">
      {issues.map((issue) => (
        <li
          key={issue.id}
          className="flex items-center gap-3 border-b border-slate-100 py-2 last:border-0"
        >
          <input
            type="checkbox"
            checked={issue.status === 'resolved'}
            disabled={isToggling}
            onChange={() => onToggleStatus(issue)}
            className="h-4 w-4"
            title={issue.status === 'resolved' ? 'Markera som ej åtgärdat' : 'Markera som åtgärdat'}
          />
          <span className="rounded bg-slate-100 px-2 py-0.5 text-xs">{issue.severity}</span>
          <Link
            to={`/sessions?session=${issue.conversationId}`}
            className="flex-1 text-sm text-slate-700 hover:text-brand-blue hover:underline"
            title="Öppna sessionen"
          >
            {issue.userMessage}
          </Link>
          <span className="text-xs text-slate-400">
            {issue.status === 'resolved' ? 'åtgärdat' : issue.status}
          </span>
        </li>
      ))}
    </ul>
  );
};
